import { UserRole } from '@/lib/models';
import { calculateRoleForSpace } from '@/pages/admin/user/type';
import { WorkspaceStatus, WorkspaceT } from '@/pages/workgroup/type';

// Workspace-scoped tool pages. The auto-pause prompts are deliberately limited to these: on /groups,
// /bills or /settings the user is not working inside a workspace, so interrupting them there would
// be noise.
const WORKSPACE_SCOPED_PATHS = ['/editor', '/explore', '/ingestion', '/design-schema', '/database-secrets'];

export function isWorkspaceScopedPath(pathname: string): boolean {
  return WORKSPACE_SCOPED_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

// Every status a workspace passes through from leaving Active for a pause to coming back after a
// resume.
const PAUSE_CYCLE_STATUSES: WorkspaceStatus[] = ['Pausing', 'Stopping', 'Idle', 'Stopped', 'Resuming'];

/**
 * Whether workspaceContext should keep the selected workspace selected although it is no longer
 * Active. On a tool page the auto-pause guard offers to resume it, which only makes sense while it
 * is still the selection; switching away would leave the user in some other workspace with no
 * explanation. Users who cannot resume get no prompt, so for them the selection moves on as before.
 */
export function shouldHoldPausedSelection(
  workspace: WorkspaceT | undefined,
  currentWorkspaceId: string | undefined,
  pathname: string,
  roles: UserRole[] | undefined
): boolean {
  return (
    !!workspace &&
    workspace.workspace_id === currentWorkspaceId &&
    PAUSE_CYCLE_STATUSES.includes(workspace.status) &&
    isWorkspaceScopedPath(pathname) &&
    !!roles &&
    calculateRoleForSpace(roles, workspace.workgroup_id, workspace.workspace_id) === 'workspace-admins'
  );
}
